import React, { useState } from "react";
import "./skills.css";
import Frontend from "./Frontend";
import Backend from "./Backend";
import Other from "./Other";

import {
  HiOutlineAcademicCap,
  HiOutlineBriefcase,
  HiOutlineClipboardList,
  HiOutlineChartBar,
  HiOutlineTrendingUp
} from "react-icons/hi";

import {
  SkillAreaChart,
  SkillBarChart,
  SkillBubbleChart,
  SkillLineChart,
  SkillPieChart,
  SkillRadarChart,
} from "./SkillChart";

import { FaChartBar, FaChartPie, FaChartLine } from "react-icons/fa";
import { AiOutlineAreaChart } from "react-icons/ai";
import { MdBubbleChart } from "react-icons/md";
import { GiRadarDish } from "react-icons/gi";
import Achievements from "./Achievements.jsx";

const Skills = () => {
  const [chartType, setChartType] = useState("bar");

  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index, type) => {
    setToggleState(index);
    setChartType(type);
  };

  const activeNav = 'skills__button button--flex skills__active'

  const renderChart = () => {
    switch (chartType) {
      case "bar":
        return <SkillBarChart />;
      case "radar":
        return <SkillRadarChart />;
      case "pie":
        return <SkillPieChart />;
      case "line":
        return <SkillLineChart />;
      case "area":
        return <SkillAreaChart />;
      case "bubble":
        return <SkillBubbleChart />;
      default:
        return <SkillBarChart />;
    }
  };

  return (
    <>
      <section className="section" id="skills">
        <h2 className="section__title">Skills</h2>
        <span className="section__subtitle">Technical Lvl</span>
        <div className="skills__container container grid">
          <Frontend />
          <Backend />
          <Other />
        </div>
      </section>

      <section className="section" id="skillsGraph">
        <h2 className="section__title mb-3">Skills Graph</h2>
        <div className="skills__container container">
          <div className="qualification__tabs section__title">
            <div
              className={
                toggleState === 1
                  ? activeNav
                  : "skills__button button--flex"
              }
              onClick={() => toggleTab(1, "bar")}
            >
              {/* <HiOutlineAcademicCap className="qualification__icon" /> */}
              <FaChartBar className="qualification__icon"/>
              Bar Chart
            </div>

            <div
              className={
                toggleState === 2
                  ? activeNav
                  : "skills__button button--flex"
              }
              onClick={() => toggleTab(2, "radar")}
            >
              <GiRadarDish className="qualification__icon" />
              Radar Chart
            </div>

            <div
              className={
                toggleState === 3
                  ? activeNav
                  : "skills__button button--flex"
              }
              onClick={() => toggleTab(3, "pie")}
            >
              <FaChartPie className="qualification__icon" />
              Pie Chart
            </div>

            <div
              className={
                toggleState === 4
                  ? activeNav
                  : "skills__button button--flex"
              }
              onClick={() => toggleTab(4, "line")}
            >
              <FaChartLine className="qualification__icon" />
              Line Chart
            </div>

            <div
              className={
                toggleState === 5
                  ? activeNav
                  : "skills__button button--flex"
              }
              onClick={() => toggleTab(5, "area")}
            >
              <AiOutlineAreaChart className="qualification__icon" />
              Area Chart
            </div>

            <div
              className={
                toggleState === 6
                  ? activeNav
                  : "skills__button button--flex"
              }
              onClick={() => toggleTab(6, "bubble")}
            >
              <MdBubbleChart className="qualification__icon" />
              Bubble Chart
            </div>
          </div>

          <div className="chart-container">
            {renderChart()}
          </div>

          {/* <Achievements /> */}
        </div>
      </section></>
  );
};

export default Skills;